import "../../payment.css";
export const PayBtnFree = () => {
  return (
    <div>
      <button className="paynow-btn free-btn">Upgrade</button>
    </div>
  );
};
